module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-14-2bf5d3a9f7f032360cfe2986e28f564f.png";